import { useParams } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { StudentClassDetailContext } from '../StudentClassDetailContext';
import { StudentProfileContext } from '../StudentProfileContext';
import StudentAssignmentPanel from '../../../components/student/homework/StudentAssignmentPanel';
import TopButton from '../../../components/button/TopButton';

/**
 * 개편 LMS (학생) - 클래스 상세 페이지 (할 일 목록 / 진도 지도)
 *
 * 내 학습 페이지 (/student/class) 에서 특정 class 선택 시 이동된 화면
 */
const StudentHomeworkPage = () => {
  const { classId } = useParams();

  const { getClassDetail } = useContext(StudentClassDetailContext);

  useEffect(() => {
    if (classId) {
      getClassDetail(classId);
    }
  }, [classId]);

  const { studentProfile } = useContext(StudentProfileContext);

  return (
    <div className="xl:min-height-normal_pc min-h-normal bg-gray1 py-3 xl:py-5">
      <div className="px-3 xl:px-0">
        {studentProfile && <StudentAssignmentPanel />}
      </div>
      <TopButton />
    </div>
  );
};

export default StudentHomeworkPage;
